import { call } from "redux-saga/effects";
import { APIS } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* getCustomerFeedbackDetails(action: any): any {
    const url = APIS.FEEDBACK.GET_CUSTOMER_FEEDBACK_DETAILS + action.payload.id;
    yield call(sagaFunction, action, CallApi.GET, url, null, true);
}

export function* insertFeedback(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.FEEDBACK.INSERT_FEEDBACK, action.payload, true);
}

export function* getFeedbackList(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.FEEDBACK.GET_FEEDBACK_LIST, action.payload, true);
}

export function* getFeedbackSettings(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.FEEDBACK.GET_SETTINGS, null, true);
}

export function* saveFeedbackSettings(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.FEEDBACK.SAVE_SETTINGS, action.payload, true);
}
